export default "__VITE_ASSET__DAcMSbnW__"